"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _BackendIssue = _interopRequireDefault(require("../model/BackendIssue"));

var _DisableOutOfStockRequest = _interopRequireDefault(require("../model/DisableOutOfStockRequest"));

var _EnableOutOfStockRequest = _interopRequireDefault(require("../model/EnableOutOfStockRequest"));

var _Forbidden = _interopRequireDefault(require("../model/Forbidden"));

var _InternalServerError = _interopRequireDefault(require("../model/InternalServerError"));

var _OutOfStockPage = _interopRequireDefault(require("../model/OutOfStockPage"));

var _ProviderType = _interopRequireDefault(require("../model/ProviderType"));

var _SearchOutOfStockRequest = _interopRequireDefault(require("../model/SearchOutOfStockRequest"));

var _Unauthorized = _interopRequireDefault(require("../model/Unauthorized"));

var _ValidationError = _interopRequireDefault(require("../model/ValidationError"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
* OutOfStocks service.
* @module api/OutOfStocksApi
* @version 0.17
*/
var OutOfStocksApi = /*#__PURE__*/function () {
  /**
  * Constructs a new OutOfStocksApi. 
  * @alias module:api/OutOfStocksApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function OutOfStocksApi(apiClient) {
    _classCallCheck(this, OutOfStocksApi);

    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * Disable a currenty active Out of Stock notice for a set of kitchen's location
   * **Scopes**: - `out-of-stocks:write`  Disable an Out of Stock notice which is currently enabled for a set of Kitchen's location. Once disabled, the backordered product associated to the OOS will not be replaced by its substitutes when Kitchen staff will complete their order.
   * @param {module:model/DisableOutOfStockRequest} disableOutOfStockRequest 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
   */


  _createClass(OutOfStocksApi, [{
    key: "disableOutOfStocksWithHttpInfo",
    value: function disableOutOfStocksWithHttpInfo(disableOutOfStockRequest) {
      var postBody = disableOutOfStockRequest; // verify the required parameter 'disableOutOfStockRequest' is set

      if (disableOutOfStockRequest === undefined || disableOutOfStockRequest === null) {
        throw new Error("Missing the required parameter 'disableOutOfStockRequest' when calling disableOutOfStocks");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/out-of-stocks/disable', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Disable a currenty active Out of Stock notice for a set of kitchen's location
     * **Scopes**: - `out-of-stocks:write`  Disable an Out of Stock notice which is currently enabled for a set of Kitchen's location. Once disabled, the backordered product associated to the OOS will not be replaced by its substitutes when Kitchen staff will complete their order.
     * @param {module:model/DisableOutOfStockRequest} disableOutOfStockRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "disableOutOfStocks",
    value: function disableOutOfStocks(disableOutOfStockRequest) {
      return this.disableOutOfStocksWithHttpInfo(disableOutOfStockRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Enable out of stocks notices for a set of locations
     * **Scopes**: - `out-of-stocks:write`  Create and enable a new Out of Stock notice for a product in a set of Kitchen's locations.  Once the notice is raised, the product will be considered as backordered and One Source will start to provide substitutes when Kitchen staff will validate an order contained the backordered product.
     * @param {module:model/EnableOutOfStockRequest} enableOutOfStockRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "enableOutOfStocksWithHttpInfo",
    value: function enableOutOfStocksWithHttpInfo(enableOutOfStockRequest) {
      var postBody = enableOutOfStockRequest; // verify the required parameter 'enableOutOfStockRequest' is set

      if (enableOutOfStockRequest === undefined || enableOutOfStockRequest === null) {
        throw new Error("Missing the required parameter 'enableOutOfStockRequest' when calling enableOutOfStocks");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/out-of-stocks/enable', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Enable out of stocks notices for a set of locations
     * **Scopes**: - `out-of-stocks:write`  Create and enable a new Out of Stock notice for a product in a set of Kitchen's locations.  Once the notice is raised, the product will be considered as backordered and One Source will start to provide substitutes when Kitchen staff will validate an order contained the backordered product.
     * @param {module:model/EnableOutOfStockRequest} enableOutOfStockRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "enableOutOfStocks",
    value: function enableOutOfStocks(enableOutOfStockRequest) {
      return this.enableOutOfStocksWithHttpInfo(enableOutOfStockRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Retrieve the list of current Out of Stock notices which are valid today
     * **Scopes**: - `out-of-stocks:read`  List the currently active Out of Stock notices today. This list can be filtered by using the query parameters eligible with the query.
     * @param {String} locationUuid 
     * @param {String} productUuid 
     * @param {module:model/ProviderType} providerType 
     * @param {String} providerUuid 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page  (default to 1)
     * @param {Number} opts.perPage  (default to 20)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/OutOfStockPage} and HTTP response
     */

  }, {
    key: "getCurrentOutOfStocksWithHttpInfo",
    value: function getCurrentOutOfStocksWithHttpInfo(locationUuid, productUuid, providerType, providerUuid, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'locationUuid' is set

      if (locationUuid === undefined || locationUuid === null) {
        throw new Error("Missing the required parameter 'locationUuid' when calling getCurrentOutOfStocks");
      } // verify the required parameter 'productUuid' is set


      if (productUuid === undefined || productUuid === null) {
        throw new Error("Missing the required parameter 'productUuid' when calling getCurrentOutOfStocks");
      } // verify the required parameter 'providerType' is set


      if (providerType === undefined || providerType === null) {
        throw new Error("Missing the required parameter 'providerType' when calling getCurrentOutOfStocks");
      } // verify the required parameter 'providerUuid' is set


      if (providerUuid === undefined || providerUuid === null) {
        throw new Error("Missing the required parameter 'providerUuid' when calling getCurrentOutOfStocks");
      }

      var pathParams = {};
      var queryParams = {
        'location_uuid': locationUuid,
        'product_uuid': productUuid,
        'provider_type': providerType,
        'provider_uuid': providerUuid,
        'page': opts['page'],
        'per_page': opts['perPage']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _OutOfStockPage["default"];
      return this.apiClient.callApi('/out-of-stocks/current', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Retrieve the list of current Out of Stock notices which are valid today
     * **Scopes**: - `out-of-stocks:read`  List the currently active Out of Stock notices today. This list can be filtered by using the query parameters eligible with the query.
     * @param {String} locationUuid 
     * @param {String} productUuid 
     * @param {module:model/ProviderType} providerType 
     * @param {String} providerUuid 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page  (default to 1)
     * @param {Number} opts.perPage  (default to 20)
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/OutOfStockPage}
     */

  }, {
    key: "getCurrentOutOfStocks",
    value: function getCurrentOutOfStocks(locationUuid, productUuid, providerType, providerUuid, opts) {
      return this.getCurrentOutOfStocksWithHttpInfo(locationUuid, productUuid, providerType, providerUuid, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Search for Out of Stock notices saved within product catalogue database
     * **Scopes**: - `out-of-stocks:read`  Search for all Out of Stock notices that satisfy the search query parameters.
     * @param {module:model/SearchOutOfStockRequest} searchOutOfStockRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/OutOfStockPage} and HTTP response
     */

  }, {
    key: "searchOutOfStocksWithHttpInfo",
    value: function searchOutOfStocksWithHttpInfo(searchOutOfStockRequest) {
      var postBody = searchOutOfStockRequest; // verify the required parameter 'searchOutOfStockRequest' is set

      if (searchOutOfStockRequest === undefined || searchOutOfStockRequest === null) {
        throw new Error("Missing the required parameter 'searchOutOfStockRequest' when calling searchOutOfStocks");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _OutOfStockPage["default"];
      return this.apiClient.callApi('/out-of-stocks/search', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Search for Out of Stock notices saved within product catalogue database
     * **Scopes**: - `out-of-stocks:read`  Search for all Out of Stock notices that satisfy the search query parameters.
     * @param {module:model/SearchOutOfStockRequest} searchOutOfStockRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/OutOfStockPage}
     */

  }, {
    key: "searchOutOfStocks",
    value: function searchOutOfStocks(searchOutOfStockRequest) {
      return this.searchOutOfStocksWithHttpInfo(searchOutOfStockRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);

  return OutOfStocksApi;
}();

exports["default"] = OutOfStocksApi;